const bopsAvailabilityTag = (storeDetails) => {
  const {
    pickupOptions, curbsideCutOffTime, cutOffTime,
  } = storeDetails;
  const curbsideAvailableDay = curbsideCutOffTime?.pickupRelativeDay?.toUpperCase();
  const inStoreAvailableDay = cutOffTime?.pickupRelativeDay?.toUpperCase();
  const bopsLinkTagMessage = ['In Store:', 'NA', '-', 'Curbside:', 'NA'];
  if (pickupOptions && pickupOptions.length > 1) {
    bopsLinkTagMessage[1] = inStoreAvailableDay;
    bopsLinkTagMessage[4] = curbsideAvailableDay;
  } else if (pickupOptions && pickupOptions.length === 1) {
    if (pickupOptions[0].toLowerCase() === 'in store') {
      bopsLinkTagMessage[1] = inStoreAvailableDay;
    } else {
      bopsLinkTagMessage[4] = curbsideAvailableDay;
    }
  }
  return bopsLinkTagMessage.join('');
};

export default bopsAvailabilityTag;
